<script setup lang="ts">
import { Head } from '@inertiajs/vue3'

import NotificationList from '@/components/notifications/NotificationList.vue'
import PortalLayout from '@/layouts/PortalLayout.vue'
import { destroyAllPortalCustomerNotificationsPath, portalCustomerNotificationPath, readAllPortalCustomerNotificationsPath, readPortalCustomerNotificationPath } from '@/routes'
import type { Notification } from '@/types'

defineProps<{ notifications: Notification[] }>()
</script>

<template>
  <Head title="Notifications" />
  <PortalLayout actor-type="customer">
    <NotificationList
      :notifications="notifications"
      :read-path="(id: number) => readPortalCustomerNotificationPath(id)"
      :read-all-path="readAllPortalCustomerNotificationsPath()"
      :delete-path="(id: number) => portalCustomerNotificationPath(id)"
      :delete-all-path="destroyAllPortalCustomerNotificationsPath()"
    />
  </PortalLayout>
</template>
